import { DefaultButton } from '@fluentui/react';
import { CalendarToday20Regular } from '@fluentui/react-icons';
import { useCallback } from 'react';
import { useUISettings } from '../../../context/network/http/QueryProvider/queries/UISettings';
import { getStartOf, getToday, getDefaultEndDate } from '../helpers';
import { useTimeline } from '../useTimeline';

export const TodayButton = () => {
    const { data: uiSettings } = useUISettings();
    const { currentResolution, setTimeline } = useTimeline();

    const onClick = useCallback(() => {
        const start = getStartOf(currentResolution, getToday());
        const end = getDefaultEndDate(currentResolution, start, uiSettings.settings.periodPickerSettings);
        setTimeline({
            start,
            end,
        });
    }, [currentResolution, setTimeline, uiSettings.settings.periodPickerSettings]);

    return (
        <DefaultButton onRenderIcon={() => <CalendarToday20Regular />} onClick={onClick}>
            Today
        </DefaultButton>
    );
};
